module.exports = __webpack_public_path__ + "img/4.69be09f4.webp";